import { createSelector } from 'reselect'
import { selectAccount } from './selectAccount'

export const selectAccountSubdomain = createSelector(
  selectAccount,
  account => account.subdomain
)
